<h3 class="profileCard__heading">Admin Menu</h3>

<ul class="profileCard__list">

  <li class="profileCard__item"
      *appIfInRole="['administrator', 'lead']">
    <a routerLink="/campaign/list"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'Campaigns'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-sitemap profileCard__icon profileCard__icon--blue fa-fw spacerRight"></i>
      <span class="profileCard__label">Campaigns</span>
    </a>
  </li>

  <li class="profileCard__item"
      *appIfInRole="['administrator', 'lead']">
    <a routerLink="/admin/account/list"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'Users'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-users profileCard__icon profileCard__icon--magenta fa-fw spacerRight"></i>
      <span class="profileCard__label">Users</span>
    </a>
  </li>

  <li class="profileCard__item"
      *appIfInRole="['administrator']">
    <a routerLink="/admin/entity-types"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'Entity Types'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-dice-d20 profileCard__icon profileCard__icon--salmon fa-fw spacerRight"></i>
      <span class="profileCard__label">Entity Types</span>
    </a>
  </li>

  <li class="profileCard__item"
      *appIfInRole="['administrator']">
    <a routerLink="/admin/connection-types"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'Connection Types'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-share-alt profileCard__icon profileCard__icon--deepsky fa-fw spacerRight"></i>
      <span class="profileCard__label">Connection Types</span>
    </a>
  </li>

  <li class="profileCard__item"
      *appIfInRole="['administrator']">
    <a routerLink="/admin/fields"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'Info'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-tags profileCard__icon profileCard__icon--turquoise fa-fw spacerRight"></i>
      <span class="profileCard__label">Info</span>
    </a>
  </li>

  <li class="profileCard__item"
      *appIfInRole="['administrator']">
    <a routerLink="/admin/assessment"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'Assessments'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-sliders-h profileCard__icon profileCard__icon--gold fa-fw spacerRight"></i>
      <span class="profileCard__label">Assessments</span>
    </a>
  </li>

  <li class="profileCard__item"
      *appIfInRole="['administrator']">
    <a routerLink="/admin/integrations"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'API & Integrations'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-wrench profileCard__icon profileCard__icon--gold fa-fw spacerRight"></i>
      <span class="profileCard__label">API &amp; Integrations</span>
    </a>
  </li>

  <li class="profileCard__item"
      *appIfInRole="['administrator']">
    <a routerLink="/admin/uploader/list"
       routerLinkActive="active"
       class="profileCard__link"
       [matTooltip]="'Uploads'"
       matTooltipPosition="after"
       matTooltipClass="skinny-nav-link__tooltip">
      <i class="fal fa-file-upload profileCard__icon profileCard__icon--green fa-fw spacerRight"></i>
      <span class="profileCard__label">Uploads</span>
    </a>
  </li>

</ul>
